import { useEffect, useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Table, TableHead, TableBody, TableRow, TableCell, Accordion, AccordionDetails, AccordionSummary, Pagination } from "@mui/material";

import Obj2StrArr from './Obj2StrArr.js'
import dateString from "./DateString";

import idb, { set } from './idb.js';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function ExpendeturesEl(props) {
    const { Expendetures, User, offlineExpendeturesUpdate, EscKeyStroke, DbUpload } = props;
    const [newExpendeture, setNewExpendeture] = useState({});
    const [newExpendetureDialog, setNewExpendetureDialog] = useState({ show: false });
    const [expendetureSaveEnabled, setExpendetureSaveEnabled] = useState(false);
    const [expendetureCategories, setExpendetureCategories] = useState([]);
    const [expendetureMeans, setExpendetureMeans] = useState([]);
    const [pagination, setPagination] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);
    const [expendeturesList, setExpendetureList] = useState([]);
    const [dateFromFilter, setDateFromFilter] = useState();
    const [dateToFilter, setDateToFilter] = useState();
    const [pageItemsCount, setPageItemsCount] = useState();
    const [sorting, setSortingProp] = useState({ p: 'fecha', r: false })

    // useEffect(() => console.log('Expendetures', Expendetures), [Expendetures])

    useEffect(() => {
        if (!!pageItemsCount)
            idb.set('ExpendeturesPageItemsCount', pageItemsCount)
        else
            idb.get('ExpendeturesPageItemsCount').then(c => setPageItemsCount(c || 10));
        setPagination(1);
    }, [pageItemsCount])

    useEffect(() => {
        let itemsCount = pageItemsCount || 10,
            list = Object.keys(Expendetures)
                .map(e => ({ ...Expendetures[e], key: e }));

        console.log('list', list)
        if (!list.length) {
            setPagesCount(0);
            setExpendetureList([]);
            return
        }

        if (isNaN(list[0][sorting.p]))
            list.sort((a, b) => (b[sorting.p] || '').localeCompare(a[sorting.p] || ''));
        else
            list.sort((a, b) => (b[sorting.p] || 0) - (a[sorting.p] || 0));
        if (sorting.r) list.reverse();

        if (!!dateFromFilter)
            list = list.filter(e => e.fecha && new Date(e.fecha) && new Date(e.fecha) >= new Date(dateFromFilter + 'T00:00:00'));
        if (!!dateToFilter)
            list = list.filter(e => e.fecha && new Date(e.fecha) && new Date(e.fecha) <= new Date(dateToFilter + 'T24:00:00'));
        setPagesCount(list.length > itemsCount ? Math.ceil(list.length / itemsCount) : 1);
        list = list.filter((e, i) => i < pagination * itemsCount && i >= (pagination - 1) * itemsCount);
        setExpendetureList(list);
    }, [Expendetures, pagination, dateFromFilter, dateToFilter, pageItemsCount, sorting])

    useEffect(() => {
        if (newExpendeture.category === 'addNewExpendetureCategory') {
            setNewExpendeture(p => ({ ...p, category: '' }));
            setNewExpendetureDialog({ show: true, title: 'Categoría', prop: 'category' });
        } else if (newExpendeture.mean === 'addNewExpendetureMean') {
            setNewExpendeture(p => ({ ...p, mean: '' }));
            setNewExpendetureDialog({ show: true, title: 'Medio de Pago', prop: 'mean' });
        }
        if (!newExpendetureDialog.show) {
            let
                filteredCategory = expendetureCategories
                    .filter(e =>
                        e.toLowerCase() === (newExpendeture.category || '').toLowerCase()
                        && e !== newExpendeture.category
                    )[0],
                filteredMean = expendetureMeans
                    .filter(e =>
                        e.toLowerCase() === (newExpendeture.mean || '').toLowerCase()
                        && e !== newExpendeture.mean
                    )[0];
            if (!!filteredCategory)
                setNewExpendeture(p => ({ ...p, category: filteredCategory }));
            if (!!filteredMean)
                setNewExpendeture(p => ({ ...p, mean: filteredMean }));
        }
        setExpendetureSaveEnabled(
            !!newExpendeture.concept &&
            !!newExpendeture.amount &&
            !!newExpendeture.category &&
            !!newExpendeture.provider &&
            !!newExpendeture.mean
        )
    }, [newExpendeture, newExpendetureDialog])

    useEffect(() => {
        const valArrayFromProp = (obj, prop) => {
            let arr = Object.keys(obj).map(e => Expendetures[e][prop]).toSorted() || [];
            arr = [...new Set(arr)];
            return arr.filter(e => (!!e && e !== '-'));
        }
        setExpendetureCategories(valArrayFromProp(Expendetures, 'categoria'));
        setExpendetureMeans(valArrayFromProp(Expendetures, 'medio'));
    }, [Expendetures])

    const storeExpendeture = () => {
        let data = {
            fecha: new Date().toISOString(),
            concepto: newExpendeture.concept,
            monto: newExpendeture.amount,
            categoria: newExpendeture.category,
            proveedor: newExpendeture.provider,
            medio: newExpendeture.mean,
            UserId: User.uid,
            Usuario: User.nombre,
        }
        DbUpload(Obj2StrArr(data, `/expendetures/${btoa(data.fecha)}`) || {}).then(r => {
            r && offlineExpendeturesUpdate();
            setNewExpendeture({});
        })
    }

    const cleanPropArray = (prev, custom) => {
        let arr = [...prev || [], custom || ''].filter(e => !!e).toSorted();
        return [...new Set(arr)];
    }

    useEffect(() => {
        if (!dateFromFilter) setDateToFilter('')
        if (!!dateFromFilter && !!dateToFilter && dateFromFilter > dateToFilter) {
            let tmp = dateFromFilter;
            setDateFromFilter(dateToFilter);
            setDateToFilter(tmp);
        }
    }, [dateFromFilter, dateToFilter])

    const setSorting = (prop) => {
        setSortingProp(prev => ({ p: prop, r: prev.p === prop ? !prev.r : true }))
    }

    const header = { fecha: 'Fecha', concepto: 'Concepto', monto: 'Monto', categoria: 'Categoría', proveedor: 'Proveedor', medio: 'Forma de Pago' };

    return (
        <Box sx={{
            overflow: 'auto',
            p: 2,
            height: '100%',
            width: '100%'
        }}>
            <Box
                sx={{ fontSize: 24, fontWeight: 'bold' }}
            >
                Gastos
            </Box>
            <Box
                sx={{
                    maxWidth: '400px',
                    mx: 'auto',
                }}
            >
                <Accordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}

                        sx={{ fontSize: '1.2em', fontWeight: 'bold', fontStyle: 'italic' }}
                    >
                        Registrar gasto
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                                pl: 1,
                                pt: 1,
                            }}
                        >
                            <TextField
                                id="expendetures-concept"
                                label="Concepto"
                                variant="standard"
                                value={newExpendeture.concept || ''}
                                onChange={(e) => setNewExpendeture(p => ({ ...p, concept: e.target.value }))}
                                // placeholder={col.placeHolder || ''}
                                type='text'
                            />

                            <TextField
                                id="expendetures-amount"
                                label="Monto"
                                variant="standard"
                                value={newExpendeture.amount || ''}
                                onChange={(e) => setNewExpendeture(p => ({ ...p, amount: e.target.value }))}
                                // placeholder={col.placeHolder || ''}
                                type='number'
                            />

                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="expendetures-category-label">Categoría</InputLabel>
                                <Select
                                    labelId="expendetures-category-label"
                                    id="expendetures-category"
                                    value={newExpendeture.category || ''}
                                    onChange={(e) => setNewExpendeture(p => ({ ...p, category: e.target.value }))}
                                    label="Categoría"
                                >
                                    {cleanPropArray(expendetureCategories, newExpendeture.category).map(e => (
                                        <MenuItem key={`expendetures-category-${e}`} value={e} sx={{ fontSize: '.85em' }}>{e}</MenuItem>
                                    ))}
                                    <MenuItem key={'expendetures-category-add'} value={'addNewExpendetureCategory'} sx={{ fontSize: '.85em' }}>Agregar</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                id="expendetures-provider"
                                label="Proveedor"
                                variant="standard"
                                value={newExpendeture.provider || ''}
                                onChange={(e) => setNewExpendeture(p => ({ ...p, provider: e.target.value }))}
                                // placeholder={col.placeHolder || ''}
                                type='text'
                            />

                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="expendetures-mean-label">Forma de Pago</InputLabel>
                                <Select
                                    labelId="expendetures-mean-label"
                                    id="expendetures-mean"
                                    value={newExpendeture.mean || ''}
                                    onChange={(e) => setNewExpendeture(p => ({ ...p, mean: e.target.value }))}
                                    label="Forma de Pago"
                                >
                                    {cleanPropArray(expendetureMeans, newExpendeture.mean).map(e => (
                                        <MenuItem key={`expendetures-mean-${e}`} value={e} sx={{ fontSize: '.85em' }}>{e}</MenuItem>
                                    ))}
                                    <MenuItem key={'expendetures-mean-add'} value={'addNewExpendetureMean'} sx={{ fontSize: '.85em' }}>Agregar</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box
                            sx={{
                                mt: 2,
                                textAlign: 'end',
                            }}
                        >
                            <IconButton
                                aria-label="save"
                                onClick={storeExpendeture}
                                disabled={!expendetureSaveEnabled}
                            >
                                <CloudUploadIcon color={expendetureSaveEnabled ? "success" : "disabled"} />
                            </IconButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Box>
            <Dialog
                open={Boolean(newExpendetureDialog.show)}
                onClose={() => setNewExpendetureDialog({ show: false })}
            >
                <DialogTitle>
                    Agregar {newExpendetureDialog.title || ''}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <TextField
                            id="expendetures-dialog-input"
                            variant="standard"
                            value={newExpendeture[newExpendetureDialog.prop] || ''}
                            onChange={(e) => setNewExpendeture(p => {
                                let prev = { ...p };
                                prev[newExpendetureDialog.prop] = e.target.value;
                                return prev;
                            })}
                            type='text'
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        gap: 2,
                        pr: 2
                    }}>
                    <IconButton
                        onClick={() => {
                            setNewExpendeture(p => {
                                let prev = { ...p };
                                prev[newExpendetureDialog.prop] = '';
                                return prev;
                            })
                            setNewExpendetureDialog({ show: false });
                        }}
                        color="error"
                    >
                        <CancelIcon />
                    </IconButton>
                    <IconButton
                        onClick={() => setNewExpendetureDialog({ show: false })}
                        color="success"
                    >
                        <CheckCircleIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
            <Box
                sx={{
                    mt: 2,
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'start', md: 'center' },
                    gap: 1,
                    fontSize: '.9em',
                    '& input': {
                        fontSize: '.9em',
                    },
                    '& button': {
                        transition: 'opacity .2s ease-out',
                    },
                    '&:not(:hover) button': {
                        opacity: 0
                    }
                }}
            >
                Seleccionar Fecha:
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <TextField
                        variant="standard"
                        value={dateFromFilter}
                        onChange={(e) => setDateFromFilter(e.target.value)}
                        type="date"
                    />
                    <IconButton
                        size="small"
                        onClick={() => setDateFromFilter('')}
                        disabled={!dateFromFilter}
                    >
                        <CancelIcon
                            fontSize="inherit"
                            color={dateFromFilter ? 'error' : 'inherit'}
                        />
                    </IconButton>
                    -
                    <TextField
                        variant="standard"
                        disabled={!dateFromFilter}
                        value={dateToFilter}
                        onChange={(e) => setDateToFilter(e.target.value)}
                        type="date"
                    />
                    <IconButton
                        size="small"
                        onClick={() => setDateToFilter('')}
                        disabled={!dateToFilter}
                    >
                        <CancelIcon
                            fontSize="inherit"
                            color={dateToFilter ? 'error' : 'inherit'}
                        />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        ml: 'auto',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormControl
                        variant="standard"
                    >
                        <Select
                            id="expendetures-item-count"
                            value={pageItemsCount || 10}
                            onChange={(e) => setPageItemsCount(e.target.value)}
                        >
                            <MenuItem value={5} sx={{ fontSize: '.85em' }}>5</MenuItem>
                            <MenuItem value={10} sx={{ fontSize: '.85em' }}>10</MenuItem>
                            <MenuItem value={25} sx={{ fontSize: '.85em' }}>25</MenuItem>
                            <MenuItem value={50} sx={{ fontSize: '.85em' }}>50</MenuItem>
                            <MenuItem value={100} sx={{ fontSize: '.85em' }}>100</MenuItem>
                        </Select>
                    </FormControl>
                    Items por página
                </Box>
            </Box>
            <Box
                sx={{
                    maxWidth: '95dvw',
                    overflow: 'auto',
                }}
            >
                <Table
                    size="small"
                >
                    <TableHead>
                        <TableRow
                            sx={{ '& th': { fontWeight: 'bold' } }}>

                            {Object.keys(header).map(h => (
                                <TableCell
                                    key={`ExpendeturesHeader-${h}`}
                                    onClick={() => setSorting(h)}
                                >
                                    {header[h]}{sorting.p === h ? (sorting.r ? ' ↓' : ' ↑') : ''}
                                </TableCell>
                            ))}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {expendeturesList.map(r => (
                            <TableRow
                                key={`expendetureRow-${r.key || r.n}`}
                                title={`Registrado el ${dateString(4, new Date(atob(r.key)))} por ${r.Usuario} (${r.UserId})`}
                            >
                                <TableCell>{r.fecha ? dateString(4, new Date(r.fecha)) : ''}</TableCell>
                                <TableCell>{r.concepto || ''}</TableCell>
                                <TableCell>{r.monto || ''}</TableCell>
                                <TableCell>{r.categoria || ''}</TableCell>
                                <TableCell>{r.proveedor || ''}</TableCell>
                                <TableCell>{r.medio || ''}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
            <Box
                sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                    count={pagesCount}
                    page={pagination}
                    onChange={(e, p) => { setPagination(p) }}
                    size="small"
                />
            </Box>

        </Box >
    )
}

export default ExpendeturesEl;